import { TeamDTO } from "./dtos";

export class TeamDO {	
	public id:number;
	public name:string;
	public code:string;
	public size:number;
	public userId:number;
	
	public static fromTeamDto(dto:TeamDTO):TeamDO {
		let tdo = new TeamDO();
		tdo.id = dto.id;
		tdo.updateFromDto(dto);
		
		return tdo;
	}
	
	public updateFromDto(dto:TeamDTO):void {
		this.name = dto.name;
		this.code = dto.code;
		this.size = dto.size;
		this.userId = dto.userId;
	}
}